import { httpsFile, https } from "./http";

export function index(){
    return https().get(`categories`);
}